module.exports = __webpack_public_path__ + "static/media/cowbell.dd230e2a.svg";